const header = document.querySelector("[data-header]");

const syncHeader = () => {
  if (!header) return;
  header.classList.toggle("is-scrolled", window.scrollY > 20);
};

syncHeader();
window.addEventListener("scroll", syncHeader, { passive: true });

document.querySelectorAll(".product-form").forEach((form) => {
  const fields = Array.from(form.querySelectorAll("[data-measurement-required]"));
  const error = form.querySelector("[data-measurement-error]");
  if (!fields.length) return;

  form.addEventListener("submit", (event) => {
    const firstEmpty = fields.find((field) => !field.value.trim());
    if (!firstEmpty) return;

    event.preventDefault();
    if (error) error.hidden = false;
    firstEmpty.focus();
  });

  fields.forEach((field) => {
    field.addEventListener("input", () => {
      if (error && fields.every((item) => item.value.trim())) error.hidden = true;
    });
  });
});

document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
  const main = gallery.querySelector("[data-gallery-main]");
  const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));
  if (!main || !thumbs.length) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const nextSrc = thumb.dataset.full;
      if (!nextSrc) return;
      main.src = nextSrc;
      thumbs.forEach((item) => item.classList.toggle("is-active", item === thumb));
    });
  });
});

document.querySelectorAll("[data-menu-toggle]").forEach((toggle) => {
  const drawer = document.querySelector("[data-mobile-drawer]");
  if (!drawer) return;

  toggle.addEventListener("click", () => {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!isOpen));
    drawer.hidden = isOpen;
  });
});
